import { Observable } from "../Observable.js";
class TimeoutError extends Error {
  constructor(message = "Timeout has occurred") {
    super(message);
    this.name = "TimeoutError";
  }
}
function timeout(due, config) {
  return (source) => {
    return new Observable((subscriber) => {
      const setTimeoutFn = config?.setTimeout || setTimeout;
      const clearTimeoutFn = config?.clearTimeout || clearTimeout;
      let timeoutId;
      let hasEmitted = false;
      const resetTimeout = () => {
        if (timeoutId) {
          clearTimeoutFn(timeoutId);
        }
        timeoutId = setTimeoutFn(() => {
          if (!hasEmitted) {
            subscriber.error(new TimeoutError());
          }
        }, due);
      };
      resetTimeout();
      const subscription = source.subscribe({
        next: (value) => {
          hasEmitted = true;
          clearTimeoutFn(timeoutId);
          subscriber.next(value);
          resetTimeout();
        },
        error: (err) => {
          clearTimeoutFn(timeoutId);
          subscriber.error(err);
        },
        complete: () => {
          clearTimeoutFn(timeoutId);
          subscriber.complete();
        }
      });
      return () => {
        clearTimeoutFn(timeoutId);
        subscription.unsubscribe();
      };
    });
  };
}
export {
  TimeoutError,
  timeout
};
//# sourceMappingURL=timeout.js.map
